import { moduleDefaultConfig } from "../../../config/moduleDefaultConfig";
let moduleConfig = {};
moduleConfig = {
  ...moduleDefaultConfig,
};

moduleConfig.title = "Menu";
moduleConfig.singleItemTitle = "Menu";
moduleConfig.url = "menu";
moduleConfig.moduleType = {
  listing: "block",
  view: "block",
};
moduleConfig.imageRequirement = {
  dimension: {
    width: 586,
    height: 440,
  },
  allowedExtensions: ["image/png", "image/jpg", "image/jpeg"],
  size: 1024 * 1024 * 3,
};
moduleConfig.breadcrumbs = {
  listing: {
    label: moduleConfig.title,
    url: `/${moduleConfig.url}`,
  },
  // details: {
  //   label: "Details",
  //   url: `/${moduleConfig.url}/${id}`,
  // },
  update: {
    label: "Update",
  },
  create: {
    label: "Create",
  },
}



export default moduleConfig;
